<template>
   <div class="section container mx-auto my-14  md:my-32 w-10/12 md:w-9/12 rounded-xl shadow-xl">
    <div class="grid grid-cols-3">
        <div class="col-span-3 md:col-span-1 rounded-l-xl flex items-center foto" :style="{backgroundImage: 'url(' + imageUrl + ')' }"></div>        
        
        <div class="col-span-3 md:col-span-2 flex px-6 py-12 md:px-12 flex-col flex-1 justify-evenly">
            <h1 class="text-2xl md:text-3xl font-bold text-gray-800 mb-5" v-html="autores.title"></h1>   
            <div class="flex">
                <router-link to="/autores">
                    <button class="px-4 md:px-5 py-3 md:py-4 text-sm 
                                   font-medium text-white uppercase transition-colors duration-200 transform bg-theme-blue rounded-lg lg:w-auto focus:outline-none focus:bg-indigo-400 ">
                    VER LISTADO
                </button></router-link>          
                <router-link to="/autor-inscripcion">
                    <button class="ml-4 px-4 md:px-5 py-3 md:py-4 text-sm 
                                   font-medium text-white uppercase transition-colors duration-200 transform bg-theme-sky rounded-lg lg:w-auto focus:outline-none focus:bg-indigo-400 ">
                    INSCRIBIRSE</button></router-link>
            </div>
        </div>
    </div> 
  </div>   
</template>

<script>
    export default {
        
        props: {
            'autores':Object
        },

        data(){
            return {    
                imageUrl: "" 
            }
        },

        watch:{
            autores:function(){
               this.imageUrl = `${process.env.VUE_APP_URL_CULTURAPP}${this.$props.autores.image}`
            }
        }
    }

</script>
  
<style>
.foto{
    background-size: cover;
    background-position: center center;
}
</style>
  